import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
} from "reactstrap";
import { BiX } from "react-icons/bi";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import VisibilitySelect from "./VisibilitySelect";
import "./CreateTrivia/createTrivia.css";

// TBV-671: "Update Privacy" modal for the Trivvy 3-dots menu. Shared across the
// Survey / KC / Message lists so the logic lives in one place. Sets a Trivvy's
// admin-view privacy ("Only Me" / "All Admins") via PUT /update-trivia-visibility/:id.
const UpdateTrivvyPrivacyModal = ({ open, onClose, trivvy, onUpdateSuccess }) => {
  const [visibility, setVisibility] = useState("ONLY_ME");
  const [saving, setSaving] = useState(false);

  // Sync the selection whenever the modal opens for a (different) Trivvy.
  // Legacy Trivvys with no `visibility` value default to "Only Me".
  useEffect(() => {
    const current =
      trivvy && trivvy.adminVisibility ? trivvy.adminVisibility : "ONLY_ME";
    setVisibility(current);
  }, [trivvy, open]);

  const handleSave = () => {
    if (!trivvy || !trivvy._id) {
      return;
    }
    setSaving(true);
    axios
      .put(url.updateTrivvyVisibility(trivvy._id), { adminVisibility: visibility })
      .then(() => {
        setSaving(false);
        toastContainer("Privacy updated", "success");
        if (onUpdateSuccess) {
          onUpdateSuccess(trivvy._id, visibility);
        }
        onClose();
      })
      .catch(() => {
        setSaving(false);
        toastContainer("Could not update privacy. Please try again.", "error");
      });
  };

  return (
    <Modal isOpen={open} toggle={onClose} centered className="bwai-modal">
      <ModalHeader
        className="bwai_modal_header"
        close={
          <BiX
            className="cursor-pointer"
            color="gray"
            size={30}
            onClick={onClose}
          />
        }
      >
        Update Privacy
      </ModalHeader>
      {/* .bwai-modal .modal-body has no bottom padding, so the last block
          carries the whole gap above the footer itself. */}
      <ModalBody>
        <Label className="bwai_label_caps">Who can view this Trivvy</Label>
        <div className="mb-4">
          <VisibilitySelect value={visibility} onChange={setVisibility} />
        </div>
      </ModalBody>
      <ModalFooter className="bwai_popup_footer">
        <Button
          className="bwai_btn_outline"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          className="bwai_btn_black"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateTrivvyPrivacyModal;
